import { render, staticRenderFns } from "./ExamenCalidad.vue?vue&type=template&id=4a70350d&scoped=true"
import script from "./ExamenCalidad.vue?vue&type=script&lang=js"
export * from "./ExamenCalidad.vue?vue&type=script&lang=js"
import style0 from "./ExamenCalidad.vue?vue&type=style&index=0&id=4a70350d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70350d",
  null
  
)

export default component.exports